import { Box, Radio, RadioGroup } from "@chakra-ui/react";
import { Col } from "antd";
import { Control } from "react-hook-form";
import Field from "components/Input/Field";
import { InputBaseWrapper } from "components/Features/Financeiro/FormConta/components/InputBaseWrapper";
import { ManutencaoForm } from "features/manutencao/typings/index";
import SelectTipoIntervaloRepeticao from "components/Input/SelectTipoIntervaloRepeticao/index";
import { getStringIntervaloForTipoIntervalorRepeticao } from "./util/index";
import { TipoIntervaloRepeticaoEnum } from "features/manutencao/typings";
import InputMoney from "components/Input/InputMoney";

interface FormRecorrenciaProps {
  control: Control<ManutencaoForm, any>;
  form: ManutencaoForm;
}

function FormRecorrencia({ control, form }: FormRecorrenciaProps) {
  return (
    <Box mb={2}>
      <InputBaseWrapper gutter={16}>
        <Field
          control={control}
          name="tipoRecorrencia"
          render={({ field, isInvalid }) => (
            <RadioGroup
              w="fit-content"
              display="flex"
              flexDir="column"
              value={field.value}
              onChange={field.onChange}
              mb={field.value === "recorrente" ? 4 : 0}
              ml={2}
            >
              <Radio
                isInvalid={isInvalid}
                color={isInvalid ? "red" : undefined}
                value={"recorrente"}
                mb={4}
              >
                Manutenção recorrente
              </Radio>
              <Radio
                isInvalid={isInvalid}
                color={isInvalid ? "red" : undefined}
                value={"unica"}
              >
                Uma única manutenção
              </Radio>
            </RadioGroup>
          )}
        />
        {form.tipoRecorrencia === "recorrente" ? (
          <>
            <Box as={Col} xs={12}>
              <Field
                shouldUnregister
                control={control}
                name="tipoIntervaloRepeticaoId"
                label="Periodicidade"
                rules={{
                  required: "Informe a periodicidade",
                }}
                render={({ field }) => (
                  <SelectTipoIntervaloRepeticao
                    onChange={field.onChange}
                    value={field.value}
                  />
                )}
              />
            </Box>
            {form.tipoIntervaloRepeticaoId ? (
              <Box as={Col} xs={12}>
                <Field
                  shouldUnregister
                  control={control}
                  name="intervaloRepeticao"
                  label={`A cada ${
                    form.tipoIntervaloRepeticaoId ===
                    TipoIntervaloRepeticaoEnum.Semanal
                      ? "quantas "
                      : "quantos"
                  } ${getStringIntervaloForTipoIntervalorRepeticao(
                    form.tipoIntervaloRepeticaoId as TipoIntervaloRepeticaoEnum
                  )}?`}
                  rules={{
                    required: "Informe o intervalo ",
                    validate: (v) =>
                      (Number.isInteger(Number(v)) && Number(v) > 0) ||
                      "Deve ser um número inteiro maior que 0",
                  }}
                  render={({ field }) => (
                    <InputMoney
                      {...field}
                      decimalScale={0}
                      decimalsLimit={0}
                      disableGroupSeparators
                      allowDecimals={false}
                      maxLength={4}
                      placeholder="XXXX"
                      style={{
                        textAlign: "left",
                      }}
                    />
                  )}
                />
              </Box>
            ) : null}
          </>
        ) : null}
      </InputBaseWrapper>
      <InputBaseWrapper gutter={16}>
        <Box as={Col} xs={12}>
          <Field
            control={control}
            name="data"
            label={
              form.tipoRecorrencia === "recorrente"
                ? "Data da primeira manutenção"
                : "Data de manutenção"
            }
            inputProps={{ type: "date" }}
            rules={{
              required: "Informe a data ",
            }}
          />
        </Box>
      </InputBaseWrapper>
    </Box>
  );
}

export default FormRecorrencia;
